import { BlueText } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/styles'
import { feedBackNotificationMapper } from 'pages/NotifyEvent/constant_text'
import { GreenButton } from 'pages/NotifyEvent/styles'
import React, { useMemo } from 'react'
import { SubmitHandler, UseFormGetValues, UseFormHandleSubmit } from 'react-hook-form'
import { IoCloseSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { LocationReducer } from 'types/location'
import { SectorReducer } from 'types/sector'
import { VariableReducer } from 'types/variable'
import { NotifyEventType } from 'validator/notify_event_validator'

interface INotificationConfirmation {
  handleSubmit: UseFormHandleSubmit<NotifyEventType, undefined>
  submitForum: SubmitHandler<NotifyEventType>
  getValues: UseFormGetValues<NotifyEventType>
  close: () => void
  thereIsFile: boolean
}
export default function NotificationConfirmation({ handleSubmit, submitForum, getValues, close, thereIsFile }: INotificationConfirmation) {

  //redux state
  const variableSelector: VariableReducer = useSelector(
    (state: RootReducerState) => state.variableReducers
  )
  const locationSelector: LocationReducer = useSelector(
    (state: RootReducerState) => state.locationReducers
  )
  const sectorSelector: SectorReducer = useSelector(
    (state: RootReducerState) => state.sectorReducers
  )

  const formValues = getValues()
  const infoMapper = useMemo(() => {
    return feedBackNotificationMapper(formValues, variableSelector, locationSelector, sectorSelector, thereIsFile)
  }, [formValues, variableSelector, locationSelector, sectorSelector])
  return (
    <div
      data-testid={"test-confirme-notification-modal"}
      className='md:pb-11 lg:w-[1022px]' >
      
      <div className='md:py-6 md:px-8 text-left'>
        <div className='flex items-center'>
          <BlueText className='text-lg'>Confirmação da notificação</BlueText>
          <div
            onClick={close}
            data-testid="test-close-icon"
            className=' cursor-pointer ml-auto'
          >
            <IoCloseSharp
              className="text-blueTheme h-8 w-8 p-1"
            />
          </div>
        </div>
        <p className="text-darkGray md:text-base text-xs">
          Confira o resumo da sua notificação. Caso precise alterar alguma informação, volte para o passo que desejar.
        </p>
      </div>
      <hr className={'border-[1px] md:block hidden  border-[#EBEDF2] mt-4 md:mt-0'} />
      <div className='md:px-8 md:mt-8 mt-5 text-left'>
        <div className='border border-[#EBEFF5] rounded-lg md:px-[33px] md:py-[26px] px-6 py-4'>
          <BlueText className='md:text-lg text-sm '>Resumo</BlueText>
          <div className='mt-4'>
            {
              infoMapper.map((info, idx) => {
                const hasExtraMarginText = ["Classificação do Incidente", "Unidade"]
                const topExtraMargin = hasExtraMarginText.includes(info.keyText) ? "mt-4" : ""
                return (
                  <div
                    key={idx}
                    className={`${topExtraMargin}`}
                  >
                    <NotificationFeedBackHelper
                      keyText={info.keyText}
                      valueText={info.valueText}
                    />
                  </div>
                )
              })
            }
          </div>
        </div>
        <form
          onSubmit={handleSubmit(submitForum)}
          className='mt-8'>
          <GreenButton onClick={close} className="w-full">
            <span className='text-white text-sm font-semibold	 leading-5'>Enviar notificação</span>
          </GreenButton>
        </form>
      </div>
    </div>
  )
}
export interface INotificationFeedBackHelperProps {
  keyText: string
  valueText: string
}
export const NotificationFeedBackHelper = ({ keyText, valueText, }: INotificationFeedBackHelperProps) => {
  return (
    <div className='flex md:flex-row flex-col md:gap-4 mb-1'>
      <span className='text-darkGray md:text-base text-xs'>{keyText}</span>
      <span className='text-darkGray font-semibold md:text-base text-xs'>{valueText}</span>
    </div>
  )
}